import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Form, FormInputSelect, useForm } from '@modernhealth/vital-components';

import { MemberAvailability } from 'src/generated/webapp_gql';
import type { Dispatch } from 'src/config/rootStore';
import { getAvailability } from 'src/modules/user/selectors/userSelectors';
import { availabilityOptions } from 'src/shared/models/shared';
import type { QuestionnaireType } from 'src/modules/pathways/pages/PathwayCreateQuestionnairePage';

import { CreatePathwayQuestionnaireLayout } from './CreatePathwayQuestionnaireLayout';

interface Props {
    pathwayUuid: string;
    nextQuestionnaireType?: QuestionnaireType | undefined;
}

export const CreatePathwayQuestionnaireAvailability = ({
    pathwayUuid,
    nextQuestionnaireType,
}: Props) => {
    const dispatch = useDispatch<Dispatch>();
    const { t } = useTranslation();
    const userAvailablity = useSelector(getAvailability);

    const form = useForm({
        defaultValues: {
            availability: userAvailablity ?? [],
        },
    });
    const availability = form.watch('availability');

    return (
        <CreatePathwayQuestionnaireLayout
            pathwayUuid={pathwayUuid}
            question={{
                title: t('pathways:onboarding.questionnaire.availability.subtitle'),
                description: t('pathways:onboarding.questionnaire.availability.description'),
            }}
            nextQuestionnaireType={nextQuestionnaireType}
            disabled={availability.length === 0}
            onSubmit={() =>
                dispatch.user.updateMemberProfile({
                    availability: availability as MemberAvailability[],
                })
            }
        >
            <Form definition={form}>
                <FormInputSelect
                    name="availability"
                    label={t('pathways:onboarding.questionnaire.availability.title')}
                    options={availabilityOptions?.map(a => ({ value: a, label: a })) ?? []}
                    required
                    multi
                    hint={t('pathways:onboarding.questionnaire.availability.current')}
                />
            </Form>
        </CreatePathwayQuestionnaireLayout>
    );
};
